import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledAssociationWidget = styled(Box)(({ theme }) => ({
  width: "100%",
  "@keyframes highlightWidget": {
    "0% ": { boxShadow: `0 0 0 ${theme.palette.primary.main} inset`, padding: "1px" },
    "5% ": { boxShadow: `0 0 0 ${theme.palette.primary.main} inset`, padding: "5px" },
    "25%": { boxShadow: `0 0 10px ${theme.palette.primary.main} inset`, padding: "10px" },
    "50%": { boxShadow: `0 0 0 ${theme.palette.primary.main} inset`, padding: "10px" },
    "75%": { boxShadow: `0 0 10px ${theme.palette.primary.main} inset`, padding: "10px" },
    "100%": { boxShadow: `0 0 0 ${theme.palette.primary.main} inset`, padding: "1px" },
  },
}));

export default StyledAssociationWidget;
